module.exports = __webpack_public_path__ + "static/media/BNB.eb364c45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/components/CoinCircle/icons/BNB.svg
// module id = 1510
// module chunks = 83